'use client';

import { BuyerListingFavorite } from '@/legacy/favorites/FavoritesViewModel';
import { getCollectionFilterConfig } from '@/legacy/listings/ListingsPage/v2/ListingsFilterPage/filterPageConfigs';
import { useGhostStore } from '@/legacy/store';
import { Collection } from '@/types/collections';
import { FilterAttribute } from '@/types/filterAttribute';
import { Background, FlatBuyerPreferences } from '../types';
import GenericCollection from './GenericCollection';

type Props = {
  background?: Background;
  sectionTitle: string;
  navigateTo: string;
  numPerPage: number;
  favoritesPromise: Promise<BuyerListingFavorite[]>;
  listingsIndexName: string;
  seeMoreStringComponent?: JSX.Element;
  collection: Collection;
  preferencesPromise?: Promise<FlatBuyerPreferences>;
  preferenceDependencies?: FilterAttribute[];
  index: number;
  isStockXSectionEnabled: boolean;
};

function ListingCollectionContent({
  collection,
  preferencesPromise,
  preferenceDependencies,
  ...rest
}: Props): JSX.Element {
  const currentUser = useGhostStore((state) => state.user);
  const buyerId = currentUser?.buyer?.id;

  /** Algolia filters to include/omit stealth listings based on buyer id */
  const filters = buyerId
    ? `(stealthApprovedBuyerIds:${buyerId} OR isStealth:false)`
    : 'isStealth:false';

  return (
    <GenericCollection
      configureProps={{
        tagFilters: getCollectionFilterConfig(collection).tagFilters,
        filters,
      }}
      collection={collection}
      {...rest}
    />
  );
}

export default function ListingCollection(props: Props) {
  return <ListingCollectionContent {...props} />;
}
